var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"mb-3"},[_vm._v("Crear matriz indicadora: "+_vm._s(_vm.sucursal.descripcion))]),_c('BVForm',{attrs:{"schema":_vm.schemaFichaIndicadores,"injectData":_vm.injectData,"callBackSubmit":_vm.sendData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }